var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "#F1F3FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1686_34189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8182 15.6675V14.334C22.8182 12.9193 22.2052 11.5626 21.1141 10.5623C20.023 9.56197 18.5431 9 17 9C15.4569 9 13.977 9.56197 12.8859 10.5623C11.7948 11.5626 11.1818 12.9193 11.1818 14.334V15.6675C11.164 16.0742 11.0548 16.4731 10.8613 16.8394C10.6677 17.2057 10.3938 17.5315 10.0567 17.7964C9.45105 18.2696 9.0717 18.9414 9 19.668C9 21.3349 11.9905 22.335 17 22.335C22.0095 22.335 25 21.3349 25 19.668C24.9283 18.9414 24.5489 18.2696 23.9433 17.7964C23.6062 17.5315 23.3323 17.2057 23.1387 16.8394C22.9452 16.4731 22.836 16.0742 22.8182 15.6675Z",
    fill: "#214BA5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9236 23.6018C15.0623 24.0072 15.3384 24.3614 15.7119 24.6129C16.0853 24.8644 16.5366 25 17 25C17.4634 25 17.9147 24.8644 18.2881 24.6129C18.6616 24.3614 18.9378 24.0072 19.0764 23.6018C18.4262 23.6458 17.7353 23.6685 17 23.6685C16.2647 23.6685 15.5738 23.6472 14.9236 23.6018Z",
    fill: "#214BA5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1686_34189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(9 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring-icon.19934937593f553c186952c44c3707a1.svg";
export { ForwardRef as ReactComponent };